import { render } from "./Hours.vue?vue&type=template&id=2b6228e6&scoped=true"
import script from "./Hours.vue?vue&type=script&lang=js"
export * from "./Hours.vue?vue&type=script&lang=js"

import "./Hours.vue?vue&type=style&index=0&id=2b6228e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3624/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6228e6"]])

export default __exports__